import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Payments.module.css';

type Props = {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

export function ProofShareConfirmation({ checked, disabled, onChange }: Props) {
  const { t } = useTranslation();
  const helperId = useId();
  return (
    <div>
      <label className={styles.proofConfirmation}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-describedby={helperId}
          onChange={(event) => onChange(event.target.checked)}
        />
        {t('payments.proofShareConfirmation.label')}
      </label>
      <p id={helperId} className={styles.subtle}>
        {t('payments.proofShareConfirmation.helper')}
      </p>
    </div>
  );
}
